module.exports = __webpack_public_path__ + "media/images/pages/non-gcse/tori-d7325d77e9f01448e06c5d6f0c3e2397.png";